import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
// import { NavLink } from "react-router-dom";
import {LineWave} from "react-loader-spinner";
import "react-toastify/dist/ReactToastify.css";
import logo from "../assets/altrafxlogo_black.png";
import adminbanner from "../assets/adminbanner.png";
import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo.png";
import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import axios from "axios";
import { PiArrowSquareRight } from "react-icons/pi";
import bannerimg from "../assets/userlogin.webp";
import styles from "../components/tradeall.module.css"

const Signin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [Loading, setLoading] = useState(false);






  useEffect(() => {
    verifytokenexistss()
  }, []);

  
  const verifytokenexistss = async () => {
    try {
      const tokenfromls = localStorage.getItem("token");
      // console.log("tokenfromls" , tokenfromls)

      const id = localStorage.getItem("adminregisterId");
      const h = { authorization: tokenfromls };
      // console.log(h);
      if (tokenfromls) {
        const res = await axios.get(`
          ${process.env.REACT_APP_URL}/protect/protectedroute`,
          { headers: h }
        );
        // console.log("my resp", res);
       
        if (res) {
          // console.log(res.data , "cybercure")
          if (res.data.m == id) {
            navigate("/admin/economicdata");
          }
        }
      } 
    } catch (e) {
      // console.log(e)
      if(e.response&&e.response.status===401||e.response&&e.response.status===400){
        // console.log("Token malfunction");
       
      }
    
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/admin/economicdata");
    }
  }, []);



  const validateEmail = (email) => {
    const emailRegex = /.+@.+/;
    return emailRegex.test(email);
  };

  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoggingIn(true);
    if (!validateEmail(email)) {
      toast.error("Invalid email address , @ is mandatory", {
        position: "top-right",
      });
      setIsLoggingIn(false);
      setLoading(false);
      return;
    }

    
    setLoading(true)

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/admin/login`,
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setIsLoggingIn(true);
      const data = await response.data;
      setLoading(false)
      // console.log("data" , data)
      const adminregisterId = response.data.user._id ;
      localStorage.setItem("adminregisterId" , adminregisterId )
      // localStorage.setItem("usertoken", data.usertoken);
      localStorage.setItem("token", data.token);
      setEmail("");
      setPassword("");

      navigate("/admin/economicdata");
    } catch (error) {
      setIsLoggingIn(false);

      console.error("Error during login:", error);
      toast.error("Error during login! Please check credientials again", {
        position: "top-right",
      });
      setLoading(false)
    }
  };

  return (
    <>
     <section className={`${styles.usersignin_bg}  `}>
     <div className=" py-[3.5rem] sm:py-[3.5rem] md:py-[4.5rem] lg:py-[5.5rem] xl:py-[7.5rem]  px-[1.5rem] sm:px-[1.5rem] md:px-[4rem] lg:px-[5rem] xl:px-[7rem] h-full flex w-[100%] flex-col sm:flex-col md:flex-col lg:flex-row xl:flex-row">
     <div className="w-[100%] sm:w-[100%] md:w-[100%]  lg:w-[50%] xl:w-[50%] flex justify-center items-center ">
          <img
            src={bannerimg}
            alt="bannerimg"
            className="h-[35vh] sm:h-[35vh] md:h-[35vh] lg:h-[55vh] xl:sm:h-[55vh]"
          ></img>
        </div>

        <div className=" w-[100%] z-[999] sm:w-[100%] md:w-[100%]  lg:w-[50%] xl:w-[50%] flex flex-col items-center justify-center  py-8 lg:py-0 " >
         
        <div className="rounded-[34px] w-full flex items-center justify-center sm:px-[2px] md:px-[6.5rem] lg:px-[4.5rem] xl:px-[4.5rem] px-0 py-0 sm:py-0 md:py-[3.5rem] lg:py-[4.5rem] xl:py-[7.5rem]  bg-white" style={{ boxShadow: '0px 2px 14.1px 0px rgba(223, 223, 223, 0.50)' }}>
        <div className="w-full bg-white     md:mt-0 sm:max-w-md xl:p-0 rounded-[34px] px-2 sm:px-2 md:px-0"  >
        <div className=" space-y-4 md:space-y-4  bg-white">
        <h1 className="text-[24px] sm:text-[24px] md:text-[32px] lg:text-[32px] xl:text-[32px] font-bold text-center text-[#240D3A]">Admin Sign In</h1>

<p className="text-[#240d3a] text-center font-semibold text-[14px] sm:text-[14px] md:sm:text-[14px] lg:sm:text-[16px] xl:sm:text-[16px]  ">To access your account, please provide the <br/>following information.</p>
              <form onSubmit={handleSubmit} className="my-10">
                <div className="flex flex-col ">
                  <label htmlFor="email">
                  <p className="font-bold text-[#240d3a] pb-2 mt-4">
                      Email address
                    </p>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="off"
                       className="w-full py-3 text-[14px] placeholder-[#545454] font-semibold  input-field border border-[#8692A6] rounded-lg px-5 focus:outline-none focus:border-slate-500 hover:shadow"
                      placeholder="Enter email"
                    />
                  </label>
                  <label htmlFor="password" className="relative mt-4 sm:mt-4 md:mt-0">
                  <p className="font-bold text-[#240d3a] pb-2">Password</p>
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="off"
                        className="w-full py-3 text-[14px] placeholder-[#545454] font-semibold input-field border border-[#8692A6] rounded-lg px-5 focus:outline-none focus:border-slate-500 hover:shadow pr-10"
                      placeholder="Enter password"
                    />
                    {showPassword ? (
                      <IoIosEye
                        className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      // <img src={eye_img_open}  onClick={() => setShowPassword(!showPassword)} className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500 w-[16px]"></img>
                      <IoIosEyeOff
                        className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                      // <img src={eye_img}  onClick={() => setShowPassword(!showPassword)} className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500 w-[16px]"></img>
                    )}
                  </label>

                  <button
                    type="submit"
                    className="login-btn w-full py-3 font-bold text-white bg-[#240D3A] hover:bg-gray-700 rounded-lg border-indigo-500 hover:shadow inline-flex space-x-2 items-center justify-center mt-10"
                  >
                      <span>{isLoggingIn ? "Signing you in..." : "Sign In"}</span>
                    {/* <span>Login</span> */}
                    {/* <PiArrowSquareRight className="text-xl" /> */}
                  </button>

                 
                </div>
              </form>
            </div>
          </div>
          </div>


          {
             Loading ?  <div className="fixed bottom-0 right-0 mb-2 flex items-end justify-end   w-full">
             <LineWave 
               height="60"
               width="60"
               color="#111827"
               ariaLabel="bars-loading"
               wrapperStyle={{}}
               wrapperClass=""
               visible={true}
               className=" w-10 h-10 flex items-center justify-center  mt-10 "
             />
           </div> : <div>
            
           </div>
          }
        </div>
    </div>
        
      </section>
    </>
  );
};

export default Signin;
